<template>
  <el-drawer 
    class="drawer" 
    id="branch_drawer" 
    :withHeader="false" 
    :show-close="false" 
    :destroy-on-close="true" 
    :visible.sync="isVisible" 
    size="90%"
    direction="btt"
  >
    <el-row>
      <el-col class="text-center">
        <h2 class="text-title--large">{{ $t('pageRestaurant.allbranch') }} ({{ branches.length }})</h2>
      </el-col>
    </el-row>
      <div v-for="(branch,index) in branchesSorted" :key="'b-'+index">
        <div v-if="branch.display_online_flag == '1'" class="r-branch-list">
          <el-row>
            <el-col :span="16" class="fs-wrp text-heading2--med">{{ $t('pageCheckout.branch') }} {{branch.name}}</el-col>
            <el-col  
              :span="8"
              class="r-distance text-subtitle"
            > 
              <div v-if="isBranchMapping">
                <SkeletonItem variant="body" style="width: 75%;" />
              </div>
              <div v-else>
                <div v-if="branch.delivery_info">
                  <span v-if="Number.isFinite(branch.delivery_info.price)">
                    <span>
                      <img :src="require('@/assets/icons/svg/delivery-gray.svg')"/>
                    </span>
                    {{ branch.delivery_info.price | priceFormat(0,$store.getters.currency)}}
                    <span class="mx--1">•</span>
                  </span>
                  <span>
                    {{ branch.delivery_info.dis_metre }} {{ $t('global.kilometer') }}
                  </span>
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24" class="b-address d-flex">
              <el-col :span="21">
                <label class="text-grey text-subtitle">{{branch.address}}</label>
              </el-col>
              <el-col 
                :span="3" 
                class="text-xs-end" 
              >
                <a 
                  :href="'https://www.google.com/maps/search/?api=1&query=' + branch.latitude + ',' + branch.longitude" 
                  target="_blank"
                >
                  <img 
                    :src="require('@/assets/icons/svg/direction-circle.svg')"
                    alt="google-map-link"
                  />
                </a>
              </el-col>
            </el-col>
            <el-col :span="16" v-if="branch.deliveryTime.isOpen">
              <span class="text-grey text-subtitle" v-if="branch.nextDeliveryTime.dayId != 99">
                <b class="font-green">{{ $t('pageMenuList.header.open') }}</b> 
                <span class="color-cloudburst--text">
                    {{ $t('pageMenuList.header.to') }} {{branch.deliveryTime.closeTime}}
                </span>
              </span>
              <span class="text-grey text-subtitle" v-else>
                <b class="font-green">{{ $t('pageMenuList.header.open') }}</b>
              </span>
            </el-col>
            <el-col :span="16" v-else>
              <span class="text-grey text-subtitle" v-if="branch.deliveryTime.overTimeFlag">
                <b class="font-red">{{ $t('pageMenuList.header.close') }}</b> 
                <span class="color-cloudburst--text">
                  {{ $t('pageMenuList.header.to') }} {{ branch.deliveryTime.timePeriod[0].openTime }}
                </span>
              </span>
              <span class="text-grey text-subtitle" v-else-if="!branch.deliveryTime.overTimeFlag && branch.nextDeliveryTime.dayId != 99 && $i18n.locale === 'en'">
                <b class="font-red">{{ $t('pageMenuList.header.close') }}</b>
                <span class="color-cloudburst--text">
                  {{ $t('pageMenuList.header.to') }}
                  {{ branch.nextDeliveryTime.dayId | filterDayEN }}
                  {{ branch.nextDeliveryTime.openTime }}
                </span>
              </span>
              <span class="text-grey text-subtitle" v-else-if="!branch.deliveryTime.overTimeFlag && branch.nextDeliveryTime.dayId != 99 && $i18n.locale !== 'en'">
                <b class="font-red">{{ $t('pageMenuList.header.close') }}</b>
                <span class="color-cloudburst--text">
                  {{ $t('pageMenuList.header.to') }}
                  {{ branch.nextDeliveryTime.dayId | filterDayTH }}
                  {{ branch.nextDeliveryTime.openTime }}
                </span>
              </span>
              <span class="text-grey text-subtitle" v-else><b class="font-red">{{ $t('pageMenuList.header.close') }}</b></span>
            </el-col>
            <el-col v-if="!isExpandingBranchDetail(branch)" :span="8" class="text-grey text-right pointer">
              <a class="text-subtitle" @click="expandBranchDetail(branch)">
                {{ $t('pageRestaurant.moreInfo') }} 
                <i class="icon-shape"></i>
              </a>
            </el-col>
            <el-col v-else :span="7" class="text-grey active text-right pointer">
              <a class="text-subtitle" @click="expandBranchDetail(branch)">
                {{ $t('pageRestaurant.hide') }} 
                <i class="icon-shape-up"></i>
              </a>
            </el-col>
            <template v-if="isExpandingBranchDetail(branch)">
              <el-col :span="24">
                <div class="">
                  <div class="contact-item b" v-if="branch.phone" @click="openContact(branch.phone, 'tel')">
                      <img src="@/assets/icons/phone.png" class="icon-contact b">
                      <span class="text-heading3 vertical-middle">{{ toTelephoneNumber(branch.phone) }}</span>
                  </div>
                  <div class="contact-item b" v-if="branch.fb_msg_url" @click="openContact(branch.fb_msg_url, 'facebook')">
                      <img src="@/assets/icons/thank/messenger.png" class="icon-contact b">
                      <span class="text-subtitle vertical-middle">{{branch.fb_msg_url}}</span>
                  </div>
                  <div class="contact-item b" v-if="branch.line_name" @click="openContact(branch.line_name, 'line')">
                      <img src="@/assets/icons/thank/line.png" class="icon-contact b">
                      <span class="text-subtitle vertical-middle">{{branch.line_name}}</span>
                  </div>
                  <div class="contact-item b last" v-if="branch.wlb_comment">
                      <img src="@/assets/icons/moreInfo.png" class="icon-contact b">
                      <span class="text-subtitle vertical-middle"><b>{{ $t('pageRestaurant.moreInfo') }}</b></span> <br>
                      <span class="text-subtitle ml--8 vertical-middle">{{ branch.wlb_comment }}</span>
                  </div>
                </div>
              </el-col>
            </template>
            <el-col :span="24" class="b-destinaiton m-t-7" v-if="branch.openLink">
              <!-- Display Both Button Delivery & Pickup -->
              <el-row
                v-if="hasDeliveryAndPickupService(branch)"
              >
                <el-col 
                  :span="isOnlyOneFlag(branch) ? 12 : 24" 
                  class="text-center"
                >
                  <button 
                    @click="gomenu(branch,0)" 
                    class="el-button btn-destinaiton delivery plain text-button"
                  >
                    <el-row>
                      <el-col 
                        :span="isOnlyOneFlag(branch) ? 6 : 10" 
                        class="text-right"
                      >
                        <i class="fs-icon-delivery-active">
                        </i>
                      </el-col>
                      <el-col 
                        :span="isOnlyOneFlag(branch) ? 18 : 14" 
                        class="text-left p-l-10"
                      >
                        {{ $t('pageRestaurant.delivery') }}
                      </el-col>
                    </el-row>
                  </button>
                </el-col>
                <el-col :span="isOnlyOneFlag(branch) ? 12 : 24" class="text-center">
                  <button @click="gomenu(branch,1)" class="el-button btn-destinaiton delivery plain text-button">
                    <el-row>
                      <el-col :span="isOnlyOneFlag(branch) ? 6 : 10" class="text-right"><i :class="'fs-icon-food-bag-active'"></i></el-col>
                      <el-col :span="isOnlyOneFlag(branch) ? 18 : 14" class="text-left p-l-10">{{ $t('pageRestaurant.pickup') }}</el-col>
                    </el-row>
                  </button>
                </el-col>
              </el-row>
              <!-- Display Once Button Delivery & Pickup -->
              <el-row v-else>
                  <!-- Display Button Delivery -->
                <el-col
                  v-if="hasOnlyDeliveryService(branch)"
                  :span="isOnlyOneFlag(branch) ? 12 : 24" class="text-center"
                >
                  <button 
                    @click="gomenu(branch,0)" 
                    class="el-button btn-destinaiton delivery plain text-button"
                  >
                    <el-row>
                      <el-col 
                        :span="isOnlyOneFlag(branch) ? 6 : 10" 
                        class="text-right"
                      >
                        <i :class="'fs-icon-delivery-active'"></i>
                      </el-col>
                      <el-col 
                        :span="isOnlyOneFlag(branch) ? 18 : 14" 
                        class="text-left p-l-10"
                      >
                        {{ $t('pageRestaurant.delivery') }}
                      </el-col>
                    </el-row>
                  </button>
                </el-col>
                <!-- Display Button Pickup -->
                <el-col
                  v-if="hasOnlyPickupService(branch)"
                  :span="isOnlyOneFlag(branch) ? 12 : 24" class="text-center"
                >
                  <button 
                    @click="gomenu(branch,1)" 
                    class="el-button btn-destinaiton delivery plain text-button"
                  >
                    <el-row>
                      <el-col 
                        :span="isOnlyOneFlag(branch) ? 6 : 10" 
                        class="text-right"
                      >
                        <i :class="'fs-icon-food-bag-active'"></i>
                      </el-col>
                      <el-col 
                        :span="isOnlyOneFlag(branch) ? 18 : 14" 
                        class="text-left p-l-10"
                      >
                        {{ $t('pageRestaurant.pickup') }}
                      </el-col>
                    </el-row>
                  </button>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </div>
      </div>
  </el-drawer>
</template>

<script>
import Mixins from '@/utils/mixins'
import contact from '@/utils/contact'

export default {
  props: {
    value: { default: false },
    branches: { default: () => ([]) },
    fromLocation: { default: null }
  },
  mixins: [Mixins],
  data() {
    return {
      expandingBranches: [],
      branchesMapped: [],
      isBranchMapping: false,
    }
  },
  mounted: async function() {
    try {
      this.isBranchMapping = true
      this.branchesMapped = await this.mapDeliveryFeeInfoEachBranch(this.branches)
    } finally {
      this.isBranchMapping = false
    }
  },
  methods: {
		openContact: contact.openContact,
		toTelephoneNumber: contact.toTelephoneNumber,
    close_page() {
      this.isVisible = false;
    },
    expandBranchDetail(branch) {
      const { branch_id = '' } = branch
      const branchIndex = this.expandingBranches.indexOf(branch_id)
      if (branchIndex >= 0) {
        this.expandingBranches.splice(branchIndex, 1)
      } else {
        this.expandingBranches.push(branch_id)
      }
    },
    isExpandingBranchDetail: function (branch) {
      return this.expandingBranches.includes(branch.branch_id)
    },
    isOnlyOneFlag (branch) {
      return (+branch.delivery_flag+ +branch.pickup_flag) == 2
    },
    async gomenu (branch,type) {
      const asyncLocalStorage = {
        setItem: async function (key, value) {
          await null;
          return localStorage.setItem(key, value);
        },
        getItem: async function (key) {
          await null;
          return localStorage.getItem(key);
        }
      };
      await asyncLocalStorage.setItem('branch', JSON.stringify({
        uuid: branch.branch_uuid,
        alias: branch.branch_alias || branch.branch_uuid
      }))
      if (type == 0) {
        this.$store.dispatch('setDelivery', 'delivery')
      } else {
        this.$store.dispatch('setDelivery', 'pick-up')
      }
      this.$router.push({ path: '/restaurant/' + JSON.parse(localStorage.getItem('restaurant')).alias + '/' + JSON.parse(localStorage.getItem('branch')).alias })
    },
    hasDeliveryAndPickupService: function(branch) {
      return branch.delivery_flag == 1 && branch.pickup_flag == 1 && this.hasService(branch)
    },
    hasOnlyDeliveryService: function(branch) {
      return branch.delivery_flag == 1 && branch.pickup_flag == 0 && this.hasService(branch)
    },
    hasOnlyPickupService: function(branch) {
      return branch.delivery_flag == 0 && branch.pickup_flag == 1 && this.hasService(branch)
    },
    hasService: function(branch) {
      const hasService = branch.delivery_flag == 1 || branch.pickup_flag == 1
      const isOrderingReady = branch.orderNowSetting.orderNowFlag || branch.preOrderSetting.preorderFlag
      return hasService && isOrderingReady && branch.openLink
      // const isOrderNow = branch.orderNowSetting.orderNowFlag
      // const isPreorderOpening = branch.preOrderSetting.preorderFlag
      // const isTimeOpening = branch.deliveryTime.isOpen
      // if (!branch.openLink) return false
      // return hasService && !isOrderNow && isPreorderOpening && !isTimeOpening ||
      //   hasService && !isOrderNow && isPreorderOpening && isTimeOpening ||
      //   hasService && isOrderNow && !isPreorderOpening && !isTimeOpening ||
      //   hasService && isOrderNow && !isPreorderOpening && isTimeOpening ||
      //   hasService && isOrderNow && isPreorderOpening && !isTimeOpening ||
      //   hasService && isOrderNow && isPreorderOpening && isTimeOpening
    },
    getDeliveryInfomation: async function(fromLocation, branch) {
      const distance = await this.$store.dispatch('calculateDistance', {
        origin_coordinates: [branch.latitude, branch.longitude],
        origin_address: branch.address,
        destination_address: fromLocation.address,
        destination_coordinates: [fromLocation.lat, fromLocation.lng]
      })
      const hasMininumOrder = branch.deli_min_order_flag == 1
      const minimunOrderAmount = Number.parseFloat(branch.deli_min_order_amt) || 0
      const deliveryInfo = await this.$store.dispatch('getDeliveryFee', {
        location: fromLocation,
        restaurant: this.$route.params.restaurant_uuid,
        branch: branch.branch_uuid,
        total: hasMininumOrder ? minimunOrderAmount : 0,
        distance
      })
      return deliveryInfo.data.data
    },
    mapDeliveryFeeInfoEachBranch: async function(branches) {
      if (!this.fromLocation) return branches
      return Promise.all(branches.map(async (branch) => {
        const deliveryInfo = await this.getDeliveryInfomation(this.fromLocation, branch)
        const distance = deliveryInfo ? deliveryInfo.dis_metre * 1000 : branch.distance
        return Object.assign({}, branch, {
          distance, 
          delivery_info: deliveryInfo
        })
      }))
    },
    sortBranches: function (branches) {
      const branchesWithService = branches.filter(this.hasService)
      const branchesWithoutService = branches.filter((branch) => !this.hasService(branch))
        
      const openingBranches = branchesWithService.filter(({ deliveryTime = {} }) => deliveryTime.isOpen)
      const closingBranches = branchesWithService.filter(({ deliveryTime = {} }) => !deliveryTime.isOpen)

      const openingBranchesSorted = openingBranches.sort((a, b) => a.distance - b.distance)
      const closingBranchesSorted = closingBranches.sort((a, b) => a.distance - b.distance)
      const branchesWithoutServiceSorted = branchesWithoutService.sort((a, b) => a.distance - b.distance)

      return [].concat(openingBranchesSorted, closingBranchesSorted, branchesWithoutServiceSorted)
    }
  },
  computed: {
    isVisible: {
      get: function() {
        return this.value
      },
      set: function(value) {
        this.$emit('input', value)
      }
    },
    branchesSorted: function() {
      const branches = this.branchesMapped.length ? this.branchesMapped : this.branches
      return this.sortBranches(branches)
    }
  },
};

</script>




// WEBPACK FOOTER //
// src/components/restaurant/RestaurantBranch.vue